import Vue from 'vue';
import { SelectionType } from '../model/ProductDto';
import { Tooltip } from 'bootstrap';
export default Vue.extend({
    props: {
        variants: Array,
        selectedVariant: Object,
    },
    data() {
        return {
            SelectionType: SelectionType,
        };
    },
    mounted() {
        new Tooltip(this.$el, {
            selector: '[data-bs-toggle="tooltip"]',
        });
    },
    methods: {
        onVariantSelect(variantItem) {
            this.$emit('selectedVariantChange', variantItem);
        },
    },
});
